import classNames from 'classnames'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '../../components/Typography'
import styles from './ProductDetails.module.scss'
import { ProductSpectificationProps } from './ProductDetails.types'

const ProductSpecifications = ({ items }: ProductSpectificationProps) => {
  return (
    <div className='flex flex-col'>
      {items?.map((item, index) => {
        return (
          <div
            key={index}
            className={classNames(
              'grid grid-cols-8 lg:gap-4 gap-2',
              index > 0 && 'mt-10'
            )}>
            <div className='lg:col-span-3 col-span-12'>
              <Typography
                variant={TypographyVariant.BodyXLargeBold}
                tag={TypographyTag.span}
                className='text-primary-heading'>
                {item.title}
              </Typography>
            </div>
            <div className='lg:col-span-5 col-span-12'>
              {item.attributes?.map((attribute, index) => {
                return (
                  <div
                    key={index}
                    className={classNames(
                      'flex px-4 py-[14px] mb-2 last:mb-0 rounded gap-x-4',
                      index % Number('2') === 0 && styles.tableCell
                    )}>
                    <Typography
                      variant={TypographyVariant.BodyRegularBold}
                      className='flex-1 max-w-1/2 text-secondary-muted'
                      tag={TypographyTag.p}>
                      {attribute.title}
                    </Typography>
                    <Typography
                      variant={TypographyVariant.BodyRegular}
                      tag={TypographyTag.p}
                      className='flex-1 text-secondary-muted'>
                      {attribute.value}
                    </Typography>
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ProductSpecifications
